var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M5 20h14v-2H5m14-9h-4V3H9v6H5l7 7 7-7z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }